import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImageModule } from 'primeng/image';
import { ChatImage } from '../ai-broker-chat.models';

@Component({
  selector: 'app-chat-image',
  standalone: true,
  imports: [CommonModule, ImageModule],
  template: `
    <div class="image-wrapper my-2">
      <p-image [src]="data().url" [alt]="data().alt || data().name || 'Image'" 
               [preview]="true" [width]="'100%'"
               styleClass="border-round-lg overflow-hidden shadow-2 block">
      </p-image>
      @if (data().name) {
        <div class="text-xs text-color-secondary mt-1 px-1">{{ data().name }}</div>
      }
    </div>
  `,
  styles: [`
    .image-wrapper {
      max-width: 300px;
    }
    :host ::ng-deep .p-image img {
      max-height: 400px;
      object-fit: cover;
      display: block;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChatImageComponent {
  data = input.required<ChatImage>();
}
